// resources/js/app.js

// CSS (istersen bunları da ekle)
import 'slick-carousel/slick/slick.css'
import '@fancyapps/fancybox/dist/jquery.fancybox.css'
import '../css/style.css'
import '../css/accordion.css'
import '../css/cards.css'
import '../css/fancybox.css'
import '../css/custom.css'
import '../css/bottom-sheet.css'
import '../css/portal-fixes.css'

// jQuery'yi import ETME! Global geliyor.
// import './jquery.min.js' // <-- SİL

// jQuery’li eklentiler — NPM sürümleri
import 'slick-carousel'           // $.fn.slick eklenecek (global jQuery'e)
import '@fancyapps/fancybox'      // v3 kullanıyorsan; v4 için bkz. not

// Yerel plugin’in varsa (IIFE), artık global jQuery gördüğü için sorun yaşamaz:
import './navpoints.min.js'

// Sticky için iki seçenek:
// A) jQuery’siz NPM paketi:
import Sticky from 'sticky-js'
// B) Yerel sticky.js’in varsa ve global Sticky bekleniyorsa onu import et:
// import './sticky.js'

window.Sticky = window.Sticky || Sticky;

// Kendi kodların
import './overlay-scroll-lock.js'
import './portal-navigation.js'
import './nette.js'
import './header-location-search.js'
import './bottom-sheet.js'
// DOM hazır
$(function () {
    if ($.fn.slick && $('.js-slider').length) {
        $('.js-slider').slick({ arrows: true, dots: true, adaptiveHeight: true })
    }

    if ($.fn.navpoints && $('.js-navpoints').length) {
        $('.js-navpoints').navpoints()
    }

    if ($.fancybox && $('[data-fancybox]').length) {
        $('[data-fancybox]').fancybox()
    }

    // Sticky (NPM paketi kullanıyorsan)
    if (document.querySelector('.js-sticky')) {
        new Sticky('.js-sticky', { marginTop: 16, stickyClass: 'is-sticky' })
    }



    // Null guard örneği
    const el = document.querySelector('#something')
    if (el) {
        // ...
    }
})

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allow your team to quickly build robust real-time web applications.
 */

import './echo';
